export const portfolioData = {
  name: "Sushmita Pal",
  role: "Data Analyst | Aspiring Data Scientist",
  location: "Kolkata, India",
  email: "sushmitapal072@gmail.com",
  phone: "+91-8777832204",
  profileImage: "/profile-avatar.svg",
  github: "https://github.com/SushmiPal",
  linkedin: "https://www.linkedin.com/in/sushmita-p-bb5a40285/",

  about:
    "M.Sc. Computer Science graduate with hands-on experience in data analysis, visualization, machine learning, and deep learning. Skilled in Python, SQL, and Power BI to clean data, build models, and generate actionable insights for decision-making.",

  toolsAndTechnologies: [
    {
      category: "Programming",
      items: ["Python", "SQL"],
    },
    {
      category: "Data Analysis",
      items: ["Pandas", "NumPy", "Advanced Excel"],
    },
    {
      category: "Visualization",
      items: ["Power BI", "Matplotlib", "Seaborn"],
    },
    {
      category: "Machine Learning",
      items: ["Scikit-learn", "TensorFlow", "Keras", "NLP"],
    },
  ],

  experience: [
    {
      company: "Unified Mentor Pvt. Ltd.",
      role: "Data Analyst Intern",
      period: "Oct 2025 - Jan 2026",
      highlights: [
        "Cleaned and processed structured datasets using Python (Pandas) and SQL.",
        "Built machine learning models for customer satisfaction prediction using Random Forest and XGBoost.",
        "Created Power BI dashboards to present business insights and trends.",
        "Performed exploratory data analysis (EDA) and feature engineering to improve model quality.",
      ],
    },
  ],

  featuredProject: {
    name: "Netflix Data Analysis",
    summary:
      "Analyzed Netflix titles dataset to identify trends in content type, release year, rating distribution, and genre patterns.",
    dataset: "Kaggle Netflix Movies and TV Shows Dataset",
    tools: ["Python", "Pandas", "Seaborn", "Matplotlib"],
    links: {
      code: "https://github.com/SushmiPal/netflix",
      notebook: "https://github.com/SushmiPal/netflix/blob/main/Netflix_project.ipynb",
    },
  },

  projects: [
    {
      name: "Handwritten Digit Recognition",
      tech: "Python | TensorFlow | CNN",
      dataset: "MNIST Handwritten Digits Dataset",
      model: "Convolutional Neural Network (CNN)",
      description:
        "Built and trained a CNN model on MNIST with image preprocessing, achieving 99% accuracy and visualized training performance.",
      links: {
        code: "https://github.com/SushmiPal/Handwritten_digit-recognition",
        notebook:
          "https://github.com/SushmiPal/Handwritten_digit-recognition/blob/main/Handwritten_digit_recognition%20(1).ipynb",
      },
    },
    {
      name: "Twitter Sentiment Analysis",
      tech: "Python | Keras | NLP | CNN-LSTM",
      dataset: "Kaggle Twitter Sentiment Dataset",
      model: "Hybrid CNN + LSTM",
      description:
        "Developed a hybrid CNN-LSTM deep learning model to classify tweet sentiment into positive, negative, and neutral classes.",
      // links: {
      //   code: "https://github.com/sushmitapal072/twitter-sentiment-analysis",
      //   notebook:
      //     "https://github.com/sushmitapal072/twitter-sentiment-analysis/blob/main/sentiment_analysis.ipynb",
      // },
    },
    {
      name: "Sales & Performance Dashboard",
      tech: "Power BI | DAX | Data Visualization",
      dataset: "Retail Sales Dataset",
      model: "Business Intelligence Dashboard",
      description:
        "Designed an interactive Power BI dashboard to track revenue trends, sales performance, and regional insights using calculated measures.",
      links: {
        code: "https://github.com/SushmiPal/customer_satisfaction_prediction",
        // live: "https://app.powerbi.com/",
      },
    },
    {
      name: "Personalized Healthcare Recommendation System",
      tech: "Python | Machine Learning | Data Analysis",
      dataset: "Custom Survey-Based Healthcare Dataset",
      model: "Supervised Recommendation Model",
      description:
        "Created a survey-driven healthcare recommendation model with preprocessing, feature engineering, and prediction-focused analysis.",
      links: {
        code:
          "https://github.com/SushmiPal/healthcare-recommendation-system",
        live:
          "https://healthcare-recommendation-system-4exkopfjxrtf9yxdmktfni.streamlit.app/",
      },
    },
    {
      name: "E-commerce Sales Analysis",
      tech: "Python | Pandas | Power BI",
      dataset: "E-commerce Furniture Sales Dataset",
      model: "Analytical Trend & Revenue Study",
      description:
        "Analyzed e-commerce sales data to identify top-performing products, seasonal trends, and revenue growth opportunities.",
      links: {
        code: "https://github.com/SushmiPal/e-comm_furniture",
        notebook: "https://github.com/SushmiPal/e-comm_furniture/blob/main/E-commerce_furniture.ipynb",
      },
    },
  ],

  achievements: [
    {
      label: "M.Sc. Score",
      value: 80,
      prefix: "",
      suffix: "%",
      decimals: 0,
    },
    {
      label: "B.Sc. Score",
      value: 79,
      prefix: "",
      suffix: "%",
      decimals: 0,
    },
    {
      label: "Internship Projects",
      value: 4,
      prefix: "",
      suffix: "+",
      decimals: 0,
    },
    {
      label: "Model Accuracy",
      value: 99,
      prefix: "",
      suffix: "%",
      decimals: 0,
    },
  ],

  keyAchievements: [
    "Analyzed customer satisfaction data and identified major factors impacting user ratings.",
    "Trained and compared Random Forest and XGBoost models for satisfaction prediction.",
    "Built data cleaning and visualization workflows for Netflix and e-commerce datasets.",
    "Designed end-to-end ML projects spanning NLP, CNN, and recommendation systems.",
  ],

  certifications: [
    {
      name: "Advanced Certification in Full Stack Data Science with AI and ML",
      issuer:
        "Karmick Institute in collaboration with Electronics & ICT Academy, IIT Guwahati",
      duration: "6 Months",
    },
  ],

  blogPosts: [
    {
      title: "How I Built a Twitter Sentiment Model",
      summary:
        "My workflow for preprocessing tweets and building a CNN-LSTM model for sentiment classification.",
      link: "https://github.com/sushmitapal072/twitter-sentiment-analysis",
    },
    {
      title: "Exploratory Data Analysis on Netflix Dataset",
      summary:
        "A practical EDA process to uncover trends in content type, ratings, and release years.",
      link: "https://github.com/sushmitapal072/netflix-data-analysis",
    },
    {
      title: "Power BI Dashboard for Sales Data",
      summary:
        "How I designed a clean KPI dashboard with DAX measures for actionable business insights.",
      link: "https://github.com/sushmitapal072/sales-performance-dashboard",
    },
  ],

  sections: {
    aboutTitle: "About",
    skillsTitle: "Tools & Technologies",
    experienceTitle: "Internship",
    featuredProjectTitle: "Featured Project",
    projectsTitle: "Projects",
    certificationsTitle: "Certifications",
    blogTitle: "Articles",
    contactTitle: "Contact",
  },

  hero: {
    tagline:
      "Data Analyst | Machine Learning Enthusiast | Python & Power BI",
    locationIcon: "Location:",
    separator: "|",
    resumeLabel: "Download Resume",
    contactLabel: "Contact Me",
    githubLabel: "GitHub",
    linkedinLabel: "LinkedIn",
    snapshotTitle: "Snapshot",
    snapshotRoleLabel: "Role:",
    snapshotLocationLabel: "Location:",
    snapshotStackLabel: "Core Stack:",
  },

  contact: {
    introPrefix: "For data analyst or data science opportunities, reach out at",
    introConnector: "or connect on",
    linkedinLabel: "LinkedIn",
    githubLabel: "GitHub",
    introSuffix: ".",
    form: {
      nameLabel: "Name",
      namePlaceholder: "Your name",
      emailLabel: "Email",
      emailPlaceholder: "you@example.com",
      messageLabel: "Message",
      messagePlaceholder: "Share a bit about what you would like to build.",
      submitLabel: "Send Message",
    },
  },
};
